import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
import Flex from '../atoms/Flex';
const StyledTabBar = styled.nav `
    position: relative;
    width: calc(100% + 50px);
    margin-left: -25px;
    z-index: 2;

    &:before,
    &:after {
        position: absolute;
        content: '';
        display: block;
        width: 25px;
        height: 100%;
        top: 0;
        z-index: 2;
    }

    &:before {
        left: 0;
        background: rgb(255, 255, 255);
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0.001) 100%
        );
        border-top-left-radius: 6px;
    }

    &:after {
        right: 0;
        background: rgb(255, 255, 255);
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.001) 0%,
            rgba(255, 255, 255, 1) 100%
        );
        border-top-right-radius: 6px;
    }
`;
const StyledTabBarWrapper = styled.div `
    position: relative;

    &:before {
        position: absolute;
        content: '';
        display: block;
        bottom: 1px;
        left: 25px;
        width: calc(100% - 50px);
        height: 1px;
        background-color: ${color.border.base};
        z-index: 0;

        @media only screen and (min-width: 1200px) {
            left: 25px;
            width: calc(100% - 50px);
        }
    }
`;
const StyledTabBarInner = styled.div `
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 20px 25px 0 25px;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 20px;
    margin-top: -25px;
`;
const TabBar = ({ children, className }) => {
    return (_jsx(StyledTabBar, { className: className, children: _jsx(StyledTabBarWrapper, { className: "tab-bar__wrapper", children: _jsx(StyledTabBarInner, { children: _jsx(Flex, { fullWidth: true, justifyContent: "flex-start", alignItems: "center", flexWrap: "nowrap", children: children }) }) }) }));
};
export default TabBar;
